import React from 'react';

export default function UserList({ users }) {
  return (
    <div className="user-list">
      <h3>Online Users</h3>
      <ul>
        {users.map((user, index) => (
          <li key={index}>{user}</li>
        ))}
      </ul>
    </div>
  );
}